var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEleven(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #d3d3d3;\n      }\n\n      .cls-4 {\n        fill: #dcdbdb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x5F_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_311090240"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.83,925.5h-172.94c-6.87,0-12.46-5.37-12.46-12.25v-125.89c0-6.87,5.59-12.46,12.46-12.46h172.94c6.87,0,12.46,5.59,12.46,12.46v125.89c0,6.87-5.59,12.25-12.46,12.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.94,799.83H145.78c-43.61,0-79.06-35.45-79.06-79.06V243.64c0-43.61,35.45-78.84,79.06-78.84h773.16c43.61,0,79.06,35.23,79.06,78.84v477.13c0,43.61-35.45,79.06-79.06,79.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.78,189.5c-29.86,0-54.14,24.28-54.14,54.14v477.13c0,29.86,24.28,54.14,54.14,54.14h773.16c29.86,0,54.14-24.28,54.14-54.14V243.64c0-29.86-24.28-54.14-54.14-54.14H145.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M756.53,990.38h-448.34c-30.51,0-55.64-24.92-55.64-55.64v-21.48c0-6.87,5.59-12.46,12.46-12.46h534.71c6.87,0,12.25,5.59,12.25,12.46v21.48c0,30.72-24.92,55.64-55.43,55.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M918.94,799.83H145.78c-43.61,0-79.06-35.45-79.06-79.06v-6.23h931.28v6.23c0,43.61-35.45,79.06-79.06,79.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 476.83,
    cy: 757.08,
    r: 15.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 476.83,
    cy: 757.08,
    r: 8.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 532.25,
    cy: 757.08,
    r: 15.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 532.25,
    cy: 757.08,
    r: 8.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 587.68,
    cy: 757.08,
    r: 15.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 587.68,
    cy: 757.08,
    r: 8.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.46,659.55v-94.31c0-12.25,9.88-22.13,22.13-22.13h61.87c12.25,0,22.13,9.88,22.13,22.13v94.31h29v-233.52c0-12.25,9.88-22.13,22.13-22.13h61.87c12.25,0,22.13,9.88,22.13,22.13v233.52h29v-171.65c0-12.25,9.88-22.13,22.13-22.13h61.87c12.25,0,22.13,9.88,22.13,22.13v171.65h29v-325.46c0-12.25,9.88-22.13,22.13-22.13h61.87c12.25,0,22.13,9.88,22.13,22.13v325.46h13.53c12.25,0,22.13,9.88,22.13,22.13s-9.88,22.13-22.13,22.13H345.14c-12.25,0-22.13-9.88-22.13-22.13s9.88-22.13,22.13-22.13h13.32ZM321.94,525.71c-89.8,0-162.84-73.04-162.84-162.84s73.04-162.84,162.84-162.84,162.84,73.04,162.84,162.84-73.04,162.84-162.84,162.84Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.94,514.97c-83.78,0-151.88-68.32-151.88-152.1s68.1-151.88,151.88-151.88,151.88,68.1,151.88,151.88-68.1,152.1-151.88,152.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.46,693.06h-61.87c-6.23,0-11.17-5.16-11.17-11.39v-116.44c0-6.23,4.94-11.17,11.17-11.17h61.87c6.23,0,11.39,4.94,11.39,11.17v116.44c0,6.23-5.16,11.39-11.39,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M577.58,693.06h-61.87c-6.23,0-11.17-5.16-11.17-11.39v-255.64c0-6.23,4.94-11.39,11.17-11.39h61.87c6.23,0,11.39,5.16,11.39,11.39v255.64c0,6.23-5.16,11.39-11.39,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M712.71,693.06h-61.87c-6.23,0-11.17-5.16-11.17-11.39v-193.77c0-6.23,4.94-11.39,11.17-11.39h61.87c6.23,0,11.39,5.16,11.39,11.39v193.77c0,6.23-5.16,11.39-11.39,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M847.84,693.06h-61.87c-6.23,0-11.17-5.16-11.17-11.39v-347.59c0-6.02,4.94-11.17,11.17-11.17h61.87c6.23,0,11.39,5.16,11.39,11.17v347.59c0,6.23-5.16,11.39-11.39,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.94,233.54c-71.32,0-129.54,58-129.54,129.33s58.22,129.54,129.54,129.54,129.54-58,129.54-129.54-58.22-129.33-129.54-129.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.41,439.35c-8.59,0-16.76-3.44-22.77-9.45s-9.24-13.96-9.24-22.56,3.22-16.54,9.24-22.56c6.02-6.23,14.18-9.45,22.77-9.45s16.54,3.44,22.56,9.45,9.45,13.96,9.45,22.56-3.44,16.54-9.45,22.56-14.18,9.45-22.56,9.45ZM366.41,397.89c-2.58,0-4.94.86-6.87,2.79-1.72,1.72-2.79,4.08-2.79,6.66s1.07,4.94,2.79,6.66c3.65,3.65,9.88,3.65,13.53,0,1.72-1.72,2.79-4.08,2.79-6.66s-1.07-4.94-2.79-6.66c-1.72-1.93-4.3-2.79-6.66-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.47,350.63c-8.38,0-16.54-3.44-22.56-9.45-12.46-12.46-12.46-32.65,0-45.33,6.02-6.02,14.18-9.24,22.56-9.24s16.76,3.22,22.77,9.24c12.46,12.67,12.46,32.87,0,45.33-6.02,6.02-14.18,9.45-22.77,9.45ZM277.47,309.16c-2.36,0-4.94.86-6.66,2.58-3.65,3.87-3.65,9.88,0,13.53s9.88,3.65,13.53,0,3.65-9.67,0-13.53c-1.93-1.72-4.3-2.58-6.87-2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.99,437.2c-2.79,0-5.8-1.29-7.95-3.44-4.3-4.3-4.3-11.39,0-15.9l125.89-125.67c4.3-4.51,11.39-4.51,15.9,0,4.3,4.3,4.3,11.39,0,15.9l-125.89,125.67c-2.15,2.15-4.94,3.44-7.95,3.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883.5,693.06H345.14c-6.23,0-11.39-5.16-11.39-11.39s5.16-11.17,11.39-11.17h538.36c6.23,0,11.17,4.94,11.17,11.17s-4.94,11.39-11.17,11.39Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEleven);
export default __webpack_public_path__ + "static/media/eleven.30a8196fd299093b18c1d699a6a09c74.svg";
export { ForwardRef as ReactComponent };